import { TimeZoneCheckResponseInfo } from "@/data/info/time-zone-check-reponse-info";
import { AuthRepository } from "@/domain/repository/auth-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class TimeZoneCheckUsecase {
  constructor(private readonly authRepository: AuthRepository) {}

  async execute(): Promise<SATResult<TimeZoneCheckResponseInfo, SATError>> {
    const result = await this.authRepository.checkTimeZone();
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return SATResult.success(result.value!);
  }
}
